<button *ngIf="active && !pending && (isCollapsed || activeNotification)" class="reopen-button" (click)="open()">
  <img src="../../../../assets/img/qrcode-solid.svg" alt="GS1 QR Support Icon" class="button-icon" />
  <span>Besoin d’aide ? </span>
</button>
<div class="popup-container" *ngIf="active && !pending && !isCollapsed && !activeNotification">
  <div class="popup-content">
    <div class="popup-content-header">
        <button class="close-button" (click)="close()">×</button>
      <img src="../../../../assets/img/assistance_qrcode.png" alt="GS1 QR Support Image" class="popup-image" />
    </div>
    <div class="popup-content-body" >
      <p class="popup-text">
      Besoin d’accompagnement pour mettre en place le QR Code augmenté GS1 ?
    </p>
    </div>
    <div class="popup-content-footer" >
      <button class="contact-button" (click) = "redirect()">Nous contacter</button>
    </div>
    
  </div>
</div>